import { useState, useEffect } from 'react';
import { Project } from 'core/models/project';
import { VehicleTelemetryRepository } from 'core/repositories/FMS/VehicleTelemetryRepository';
import { useVehicleTelemetryRepositoryFactory } from './useVehicleTelemetryRepositoryFactory';
import { cancellable } from './utility/cancellable';

export function useVehicleTelemetryRepository(projectId: Project.Id) {
    const factory = useVehicleTelemetryRepositoryFactory();

    const [repository, set] = useState<VehicleTelemetryRepository>();

    useEffect(() => {
        return cancellable(async isCancel => {
            const repository = await factory.create(projectId);
            if (isCancel()) return;
            set(repository);
        });
    }, [factory, projectId]);

    useEffect(() => {
        return () => {
            if (!repository) return;
            factory.destroy(repository); // intentionally not awaiting
        };
    }, [factory, repository]);

    return repository;
}
